import React from 'react'
import { NavLink } from 'react-router-dom'
import { cn } from '../lib/cn'

interface NavbarItemProps {
  children: React.ReactNode
  selected?: boolean
  onClick?: () => any
  url: string
  className?: string
}

const styles = {
  default: 'text-primary',
  selected: 'bg-primary text-inverse',
}

const overlayStyle = {
  default: 'hover:bg-black active:bg-black hover:opacity-5 active:opacity-10',
  selected: 'active:bg-black hover:bg-white hover:opacity-20 active:opacity-20',
}

export default function NavbarItem({
  url,
  children,
  selected = false,
  className,
  onClick,
}: NavbarItemProps) {
  const variant = selected ? 'selected' : 'default'
  return (
    <NavLink
      to={url}
      onClick={onClick}
      className={({ isActive }) =>
        cn(
          'relative flex justify-center items-center py-2 px-3 rounded-[12px] overflow-hidden uppercase',
          styles[isActive ? 'selected' : 'default'],
          className,
        )
      }
    >
      {children}
      {!selected ? (
        <div
          className={cn(
            'absolute left-0 right-0 top-0 bottom-0 opacity-0 transition-all',
            overlayStyle[variant],
          )}
        />
      ) : null}
    </NavLink>
  )
}
